export interface LeadMetric { id: number; owner: number; source: string; created_at: number; campaign: string }
export function madridDay(timestamp: number) {
  return new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Madrid", year: "numeric", month: "2-digit", day: "2-digit" }).format(timestamp);
}
export function addDays(day: string, count: number) {
  return new Date(Date.parse(`${day}T12:00:00Z`) + count * 86_400_000).toISOString().slice(0, 10);
}
export function weekStart(timestamp: number) {
  const day = madridDay(timestamp);
  const weekday = new Date(`${day}T12:00:00Z`).getUTCDay();
  return addDays(day, -((weekday + 6) % 7));
}
export function validWeek(day: string) {
  return /^\d{4}-\d{2}-\d{2}$/.test(day) && Number.isFinite(Date.parse(`${day}T12:00:00Z`)) &&
    new Date(`${day}T12:00:00Z`).toISOString().slice(0, 10) === day && new Date(`${day}T12:00:00Z`).getUTCDay() === 1;
}
export function aggregateWeek(rows: LeadMetric[], start: string, ownId?: number) {
  const end = addDays(start, 7);
  const selected = rows.filter(r => (ownId === undefined || r.owner === ownId) && madridDay(r.created_at) >= start && madridDay(r.created_at) < end);
  const groups = new Map<string, { source: string; owner: number; count: number }>();
  const campaigns = new Map<string, { source: string; campaign: string; count: number }>();
  for (const row of selected) {
    const key = `${row.source}:${row.owner}`;
    const group = groups.get(key) ?? { source: row.source, owner: row.owner, count: 0 }; group.count++; groups.set(key, group);
    const campaignKey = JSON.stringify([row.source, row.campaign]);
    const campaign = campaigns.get(campaignKey) ?? { source: row.source, campaign: row.campaign, count: 0 }; campaign.count++; campaigns.set(campaignKey, campaign);
  }
  return { start, end, total: selected.length, groups: [...groups.values()].sort((a, b) => b.count - a.count),
    campaigns: [...campaigns.values()].sort((a, b) => b.count - a.count) };
}
